import Rectangle from "./Rectangle";
import Length from "./Length";
import AbstractShape from "./AbstractShape";
import Area from "./Area";

export default class Kite extends AbstractShape {
	static NAME = "kite";

	constructor( width, height_top, height_bottom ) {
		super();

		this.width = width;
		this.height_top = height_top;
		this.height_bottom = height_bottom;
	}

	get_name() {
		return Kite.NAME;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.get_width(), this.get_height() );
	}

	get_area() {
		const area = ( this.get_height().in_mm() * this.get_width().in_mm() ) / 2;

		return new Area( area );
	}

	get_circumference() {
		const halfWidth = this.get_width().divide( 2 ).in_mm();
		const upperSlope = Math.sqrt( this.get_height_top().in_mm() ** 2 + halfWidth ** 2 );
		const lowerSlope = Math.sqrt( this.get_height_bottom().in_mm() ** 2 + halfWidth ** 2 );
		const perimeter = 2 * ( upperSlope + lowerSlope );

		return new Length( perimeter );
	}

	get_width() {
		return this.width;
	}

	get_height() {
		return this.height_top.add( this.height_bottom );
	}

	get_height_top() {
		return this.height_top;
	}
	get_height_bottom() {
		return this.height_bottom;
	}

	get_maximum_dimensions( maximum_rectangle ) {
		const longest_side = maximum_rectangle.get_longest_side();
		const height_top = longest_side.divide( 3 ).in_mm();
		const height_bottom = height_top + ( height_top / 2 );

		return {
			width: maximum_rectangle.get_shortest_side(),
			height_top: new Length( height_top ),
			height_bottom: new Length( height_bottom ),
		};
	}

	get_dimension_keys() {
		return [ "width", "height_top", "height_bottom" ];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			width: this.width.in_mm(),
			height_top: this.height_top.in_mm(),
			height_bottom: this.height_bottom.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new Kite( new Length( primitives.width ), new Length( primitives.height_top ), new Length( primitives.height_bottom ) );
	}

}
